<script>
  export default {
    methods: {
      onChangePage (page) {
        this.$emit('change-page', page)
      },
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
    },
    props: {
      data: {
        type: Array,
        required: true,
      },
      dataLoading: {
        type: Boolean,
        default: false,
      },
      sortOrder: {
        type: Array,
        required: true,
      },
    },
  }
</script>
